import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import type { UpdateEmailContentRequestDto } from '@/api/generated';

import { useEmailApiClient } from '@/api/clients/useEmailApiClient.util.ts';
import { useUserContext } from '@/contexts/userContext/User.context.ts';

type Req = {
  dto: UpdateEmailContentRequestDto;
  emailId: string;
};

type Response = void;

type Return = {
  getEmailAiSuggestion: (req: Req) => Promise<Response>;
  isGettingEmailAiSuggestion: boolean;
};

export const useGetEmailAiSuggestion = (): Return => {
  const { aIEmailUpdaterApi } = useEmailApiClient();
  const { userId } = useUserContext();
  const { isPending, mutateAsync } = useMutation<Response, AxiosError, Req>({
    mutationFn: async req => {
      const { data } = await aIEmailUpdaterApi.updateEmailContent(userId, req.emailId, req.dto);
      return data;
    },
  });

  return {
    getEmailAiSuggestion: mutateAsync,
    isGettingEmailAiSuggestion: isPending,
  };
};
